.checkboxWrapper {
	margin-left: -8px;
	padding-top: calc(2 * var(--jpo-common-base-spacing));
}
